@if (isVisible || (isNotHandset$ | async)) {
  <form class="material-search-form material-search-override text-black-50" matAutocompleteOrigin #origin="matAutocompleteOrigin" >
    <mat-form-field class="material-search-form-full-width search-input" appearance="fill" color="accent">
      <button mat-icon-button matPrefix>
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button mat-icon-button matPrefix>
        <mat-icon>search</mat-icon>
      </button>
      <input type="search" class="" placeholder="Patients Search" #searchQuery
        matInput [matAutocomplete]="queryResults" [matAutocompleteConnectedTo]="origin"
        xuiSearchBox [formControl]="searchFormControl" [searchObservable]="searchObservable()" (results)="onSearchResults($event)" (searchError)="onError($event)">
      <button mat-icon-button matSuffix (click)="toggleSearch()">
        <mat-icon>clear</mat-icon>
      </button>
      <mat-autocomplete #queryResults="matAutocomplete">
        <table mat-table [dataSource]="dataSource" matSort style="width: 100%">
          <!-- Position Column -->
          <ng-container matColumnDef="profileId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> File No. </th>
            <td mat-cell *matCellDef="let element"> {{element.profileId.toString().padStart(4, '0')}} </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.firstName + ' ' + element.middleNames}} </td>
          </ng-container>
          <!-- Weight Column -->
          <ng-container matColumnDef="surname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Surname </th>
            <td mat-cell *matCellDef="let element"> {{element.surname}} </td>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="nickname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nickname </th>
            <td mat-cell *matCellDef="let element"> {{element.nickname}} </td>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="tel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tel No </th>
            <td mat-cell *matCellDef="let element"> {{element.tel}} </td>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="cell">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cell No </th>
            <td mat-cell *matCellDef="let element"> {{element.cell}} </td>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="identityNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID No </th>
            <td mat-cell *matCellDef="let element"> {{element.identityNumber}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="rowSelected(row)"></tr>
        </table>
        @for (option of searchResults$ | async; track option) {
          <mat-option [value]="option">
            <ng-container *ngTemplateOutlet="resultsCardTemplate(); context: { searchResult: option, searchQuery: searchQuery.value }">
            </ng-container>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
}
